import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const RELOAD_AT_KEY = 'kensuke:lazy-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 30_000;

type DefaultExportModule<P> = { default: ComponentType<P> };

/**
 * Vite デプロイ後に古いチャンクを取りに行って dynamic import が失敗したとき、
 * 短時間に1回だけハードリロードして復帰する（無限リロード防止）。
 */
export function lazyWithChunkReload<P extends object = object>(
  importer: () => Promise<DefaultExportModule<P>>,
): LazyExoticComponent<ComponentType<P>> {
  return lazy(async () => {
    try {
      return await importer();
    } catch (error) {
      let lastAt = 0;
      try {
        lastAt = Number(sessionStorage.getItem(RELOAD_AT_KEY) || '0');
      } catch {
        /* private mode 等 */
      }
      if (!(Number.isFinite(lastAt) && Date.now() - lastAt < RELOAD_COOLDOWN_MS)) {
        try {
          sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
        } catch {
          /* ignore */
        }
        window.location.reload();
        return new Promise<DefaultExportModule<P>>(() => {
          /* reload 完了まで解決しない */
        });
      }
      throw error;
    }
  });
}
